import { PapiComment } from '@wix/da-papi-types';
import { reduxKey } from './constants';
import { CommentStoreState } from './types';

export const getCommentState = commentId => state =>
  (commentId && state[reduxKey][commentId]) || {};

export const isInitialized = commentId => state =>
  commentId &&
  state[reduxKey] !== undefined &&
  state[reduxKey][commentId] !== undefined;

export const isFeatured = commentId => state =>
  getCommentState(commentId)(state)['isFeatured'];

export const isLiked = commentId => state =>
  getCommentState(commentId)(state)['isLiked'];

export const isHidden = commentId => state =>
  getCommentState(commentId)(state)['isHidden'];

export const isSpam = commentId => state =>
  getCommentState(commentId)(state)['isSpam'];

export const getLikes = commentId => state =>
  getCommentState(commentId)(state)['likes'];

export const isCommentReduxReady = state => !!state[reduxKey];

export function getCommentsByUser(state: CommentStoreState, userId: number) {
  const comments = state[reduxKey];

  const commentsByUser: PapiComment[] = [];
  for (const commentId in comments) {
    const comment: PapiComment = state[commentId];
    if (comment?.user?.userId === userId) {
      commentsByUser.push(comment);
    }
  }

  return commentsByUser;
}
